import { Box, TableCell, TableRow } from '@mui/material'

import { SelectorItem } from '../UserOrGroupSelector'
import GroupAvatar from 'features/account/ui/AccountGroups/AccountGroupsTable/GroupAvatar'
import UserAvatar from 'features/users/ui/UserAvatar'
import UserEmail from 'features/account/ui/AccountUsers/AccountUsersTable/UserEmail'
import { getRole } from 'features/users/model/user'
import { UserRoleLabels } from 'features/users'
import { MoreVertOutlined } from '@mui/icons-material'
import { ContextMenuIcon, ContextMenuItem } from 'features/common/ui/ContextMenu'
import { FormattedMessage } from 'react-intl'
import { Typography } from '@carto/meridian-ds/components'

function SharedWithItemsRow({
  item,
  onResend: handleResend,
  onRevoke: handleRevoke,
  hideRole,
  hideActions,
  disabled
}: {
  item: SelectorItem
  onResend?: (item: SelectorItem, action?: 'resend' | 'revoke') => void
  onRevoke: (item: SelectorItem, action?: 'resend' | 'revoke') => void
  hideRole?: boolean
  hideActions?: boolean
  disabled?: boolean
}) {
  const actions: ContextMenuItem[] = [
    ...(item.type === 'user'
      ? [
          {
            id: 'resend',
            label: <FormattedMessage id="common.button.resend" />
          }
        ]
      : []),
    {
      id: 'revoke',
      label: <FormattedMessage id="common.button.revoke" />,
      divider: item.type === 'user',
      destructive: true
    }
  ]

  const handleOpenMenu = (menu: ContextMenuItem) => {
    const fn = menu.id === 'resend' ? handleResend : handleRevoke
    fn?.(item, menu.id === 'resend' ? 'resend' : 'revoke')
  }
  return (
    <TableRow>
      <TableCell width={32} padding="checkbox">
        {item.type === 'group' ? <GroupAvatar group={item.data} /> : <UserAvatar user={item.data} />}
      </TableCell>
      <TableCell width={310}>
        <Box width="inherit" overflow="hidden">
          {item.type === 'group' ? (
            <Typography
              variant="body2"
              color="textPrimary"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              overflow="hidden"
            >
              {item.data.customName}
              <Typography component="p" variant="caption" color="text.secondary">
                {item.data.users} <FormattedMessage id="common.shareDialog.shareWithGroups.members" />
              </Typography>
            </Typography>
          ) : (
            <UserEmail user={item.data} showAuthMethod={item.repeated} />
          )}
        </Box>
      </TableCell>

      {!hideRole && (
        <TableCell width={120}>
          <Typography variant="body2" color="textSecondary">
            {item.type === 'group' ? 'Editor' : UserRoleLabels[getRole(item.data)]}
          </Typography>
        </TableCell>
      )}

      {!hideActions && (
        <TableCell width={48} align="right" padding="checkbox">
          <ContextMenuIcon
            aria-label="actions"
            menuItems={actions}
            placement="bottom-end"
            onClickItem={handleOpenMenu}
            alignRight={true}
            disabled={disabled}
          >
            <MoreVertOutlined />
          </ContextMenuIcon>
        </TableCell>
      )}
    </TableRow>
  )
}

export default SharedWithItemsRow
